var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BQdtCard',{attrs:{"name":"turnoverTitle","type":"header-item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }